// extracted by mini-css-extract-plugin
module.exports = {"multioption":"DivisionTeamsFormList_multioption__ps2tT","remove":"DivisionTeamsFormList_remove__27Lxy","add":"DivisionTeamsFormList_add__33HsI"};